module.exports = __webpack_public_path__ + "img/404.7fc9313.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/404.jpg
// module id = oJ4t
// module chunks = 23